import { render, staticRenderFns } from "./contentDetail.vue?vue&type=template&id=3da17b8c&scoped=true&"
import script from "./contentDetail.vue?vue&type=script&lang=js&"
export * from "./contentDetail.vue?vue&type=script&lang=js&"
import style0 from "./contentDetail.vue?vue&type=style&index=0&id=3da17b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da17b8c",
  null
  
)

component.options.__file = "contentDetail.vue"
export default component.exports